import { render, staticRenderFns } from "./actions.vue?vue&type=template&id=212edca4&scoped=true&lang=pug"
import script from "./actions.vue?vue&type=script&lang=js"
export * from "./actions.vue?vue&type=script&lang=js"
import style0 from "./actions.vue?vue&type=style&index=0&id=212edca4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212edca4",
  null
  
)

export default component.exports